import Vue from "vue"
import vueTippy from "vue-tippy"

Vue.use(vueTippy)
